import { render, staticRenderFns } from "./BranchExpenses.vue?vue&type=template&id=db9724ee&"
import script from "./BranchExpenses.vue?vue&type=script&lang=js&"
export * from "./BranchExpenses.vue?vue&type=script&lang=js&"
import style0 from "./BranchExpenses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports